import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  constructor() { }
  @Output() closeBar = new EventEmitter<boolean>();
  ngOnInit() {
  }
  closeSidebar() {
  this.closeBar.emit(false);
  }

}
